import API from "@irati/utils/services/API";
import endpoints from "../endpoints";
import loginErrorHandler from "./errors/loginErrorHandler";
import codes from "../errorCodes/Login";
var codesToIgnore = [codes.ExpiredConfirmationCode, codes.PasswordCriteriaFailed, codes.PasswordTooWeak, codes.UserDisabled];
var Password = /** @class */ (function () {
    function Password() {
    }
    Password.prototype.forgot = function (email, tenant, options) {
        if (options === void 0) { options = {}; }
        var data = { email: email, tenant: tenant.uuid };
        return API.post(endpoints.requestForgotPassword(), data, options)
            .then(function () {
            return true;
        })
            .catch(loginErrorHandler);
    };
    Password.prototype.setForgot = function (userId, confirmation, newPassword, options) {
        if (options === void 0) { options = {}; }
        var data = {
            userId: userId,
            confirmation: confirmation,
            new_password: newPassword
        };
        API.sentryIgnoreError(options, codesToIgnore);
        return API.post(endpoints.setForgotPassword(), data, options)
            .then(function (res) { return res.data; })
            .catch(loginErrorHandler);
    };
    Password.prototype.setLoginChallenge = function (newPassword, challenge, options) {
        if (options === void 0) { options = {}; }
        var data = {
            challengeName: challenge.challengeName,
            user: challenge.userId,
            session: challenge.session,
            challengeData: {
                newPassword: newPassword
            }
        };
        API.sentryIgnoreError(options, codesToIgnore);
        return API.post(endpoints.loginChallenge(), data, options)
            .then(function (res) { return res.data; })
            .catch(loginErrorHandler);
    };
    Password.prototype.change = function (user, oldPassword, newPassword, options) {
        if (options === void 0) { options = {}; }
        var data = {
            userId: user.uuid,
            new_password: newPassword,
            old_password: oldPassword
        };
        API.sentryIgnoreError(options, codesToIgnore);
        return API.post(endpoints.setPassword(), data, options)
            .then(function (res) { return res.data; })
            .catch(loginErrorHandler);
    };
    return Password;
}());
var service = new Password();
export var changePassword = service.change;
export var setLoginChallengePassword = service.setLoginChallenge;
export var forgotPassword = service.forgot;
export var setForgotPassword = service.setForgot;
export default service;
